/**
 *
 * @module sessionDeviceInfo
 *
 */

import Check from 'check-types';
import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class SessionDeviceInfo
 * @desc Represents the session device info provided by the service.
 *
 */
export default class SessionDeviceInfo {

    /**
     *
     * @param {String} id
     * @param {String} platform
     *
     */
    constructor(id, platform) {

        const errorMessage = {
            ctor: 'SessionDeviceInfo(id, platform)',
            get id() {
                return `${this.ctor} id should be a String with length`;
            },
            get platform() {
                return `${this.ctor} platform should be a String with length`;
            }
        };

        nonEmptyString(id, errorMessage.id, InvalidArgumentException);
        nonEmptyString(platform, errorMessage.platform, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.id = id;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.platform = platform;

    }

}



// WEBPACK FOOTER //
// ./src/services/session/sessionDeviceInfo.js